import { configureStore } from "@reduxjs/toolkit";
import feedbackReducer from "../features/feedbacks/feedbacks_slice";
import eventsReducer from "../features/events/events_slice";
import businessReducer from "../features/business/business_slice";

const store = configureStore({
  reducer: {
    feedbacks: feedbackReducer,
    events: eventsReducer,
    business: businessReducer,
  },
});

export default store;
